import { render } from "./nimp_text.vue?vue&type=template&id=452078d9"
import script from "./nimp_text.vue?vue&type=script&lang=js"
export * from "./nimp_text.vue?vue&type=script&lang=js"

import "./nimp_text.vue?vue&type=style&index=0&id=452078d9&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__